import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter'
import './TrademarkApplicationDetails.css'

export default function TrademarkApplicationDetails({ application, isMobile }) {
  return (
    <div className='TrademarkApplicationDetails'>
        <div className='container'>
          <div className='containerItem'>
            <div className='group'>
              <div className='header'>Application Number</div>
              <div>{application.applicationNumber? application.applicationNumber:'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Client</div>
              <div>{application.clientName? capitalizeFirstLetter(application.clientName):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Client ID</div>
              <div>{application.clientID? application.clientID:'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Applicants</div>
              <div>{application.applicants? capitalizeFirstLetter(application.applicants):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Applicant Address</div>
              <div>{application.applicantAddress? application.applicantAddress:'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Contact</div>
              <div>{application.contact? capitalizeFirstLetter(application.contact):'---'}</div>
            </div>
            <div className='group'>
              <div className='header'>Filing Date</div>
              <div>{application.filingDate? new Date(application.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
            </div>
          </div>
          <div className='containerItem right'>
            <div className='groupContainer'>
              <div className='group'>
                <div className='header'>Application Type:&nbsp;</div>
                <div>
                  { application.applicationType? capitalizeFirstLetter(application.applicationType):'---'}
                </div>
              </div>
              <div className='group'>
                <div className='header'>Trademark Type:&nbsp;</div>
                <div>
                  { application.trademarkType? capitalizeFirstLetter(application.trademarkType):'---'}
                </div>
              </div>
              <div className='group'>
                <div className='header'>Application Status:&nbsp;</div>
                <div>
                  { application.applicationStatus?
                  application.applicationStatus==='officeActionIssued'?'Office Action Issued':application.applicationStatus==='awaitingExam'?'Awaiting Exam':application.applicationStatus==='examReportIssued'?'Exam Report Issued':application.applicationStatus==='NOAIssued'?'NOA Issued':capitalizeFirstLetter(application.applicationStatus)
                  :
                  '---'
                  }
                </div>
              </div>
              <div className='group'>
                <div className='header'>Priority Application:&nbsp;</div>
                <div>{application.priorityApplication? application.priorityApplication:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Description:&nbsp;</div>
                <div>{application.trademarkDescription? application.trademarkDescription:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Classes:&nbsp;</div>
                <div>{application.trademarkClasses? application.trademarkClasses:'---'}</div>
              </div>
              <div className='group'>
                <div className='header'>Highly Relevant Class:&nbsp;</div>
                <div>{application.highlyRelevantTrademarkClass? application.highlyRelevantTrademarkClass:'---'}</div>
              </div>
            </div>
            <div className='groupContainer me-0'>
                <div className='group'>
                    <div className='header'>Registration Number:&nbsp;</div>
                    <div>{application.registrationNumber? application.registrationNumber:'---'}</div>
                </div>
                <div className='group'>
                <div className='header'>Filing:&nbsp;</div>
                <div>
                  {application.filing === 'useInCommerce' ? 'Use In Commerce' : application.filing === 'intentToUse' ? 'Intent To Use' : application.filing === 'baseApplication' ? 'Base Application' : application.filing === 'foreignPriority' ? 'Foreign Priority' : application.filing === 'foreignRegistration' ? 'Foreign Registration' : application.filing === 'internationalFiling' ? 'International Filing' : '---'}
                </div>
                </div>
                <div className='group'>
                <div className='header'>Filing Firm:&nbsp;</div>
                <div>{application.filingFirm? capitalizeFirstLetter(application.filingFirm):'---'}</div>
                </div>
                <div className='group'>
                <div className='header'>Firm Reference Number:&nbsp;</div>
                <div>{application.firmRefNumber? application.firmRefNumber:'---'}</div>
                </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='containerItem bottomContent'>
            <div className='groupContainer'>
                <div className='group'>
                    <div className='header'>Priority Date:&nbsp;</div>
                    <div>{application.priorityDate? new Date(application.priorityDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Registration Date:&nbsp;</div>
                    <div>{application.registrationDate? new Date(application.registrationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>National Entry:&nbsp;</div>
                    <div>{application.nationalEntryDate? new Date(application.nationalEntryDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Last Action:&nbsp;</div>
                    <div>{application.lastAction? application.lastAction:'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Next Action:&nbsp;</div>
                    <div>{application.nextAction? application.nextAction:'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Next Action Due:&nbsp;</div>
                    <div>{application.nextActionDueDate? new Date(application.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}</div>
                </div>
            </div>
            <div className='groupContainer'>
                <div className='group'>
                    <div className='header'>Fees Paid:&nbsp;</div>
                    <div>{application.feesPaid? capitalizeFirstLetter(application.feesPaid):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Approval / Denial:&nbsp;</div>
                    <div>{application.approvalOrDenial? capitalizeFirstLetter(application.approvalOrDenial):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Examination By Office:&nbsp;</div>
                    <div>{application.examinationByOffice? capitalizeFirstLetter(application.examinationByOffice):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>NOA:&nbsp;</div>
                    <div>{application.NOA? capitalizeFirstLetter(application.NOA):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>maintenanceOfRegistration:&nbsp;</div>
                    <div>{application.maintenanceOfRegistration? capitalizeFirstLetter(application.maintenanceOfRegistration):'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Classes For Search:&nbsp;</div>
                    <div className='notes'>{application.trademarkClassesForSearch? application.trademarkClassesForSearch:'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Classes For Filing:&nbsp;</div>
                    <div className='notes'>{application.trademarkClassesForFiling? application.trademarkClassesForFiling:'---'}</div>
                </div>
            </div>
            <div className='groupContainer start me-0'>
                <div className='group'>
                    <div className='header'>Notes:&nbsp;</div>
                    <div className='notes'>{application.notes? application.notes:'---'}</div>
                </div>
                <div className='group'>
                    <div className='header'>Drive Folder Location:&nbsp;</div>
                    <div>
                    {application.driveFolderLocation? 
                      <a href={application.driveFolderLocation ? application.driveFolderLocation.trim() : '#'} rel="noreferrer" target='_blank'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                        </svg>
                      </a>
                      :
                      '---'
                    }
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  )
}
